import {Button} from '@dropbox/dig-components/buttons';
import {Box} from '@dropbox/dig-foundations';
import {CancelButton} from 'components/DSYS/CancelButton';

import styles from './EditSaveButtons.module.css';

export const EditSaveButtons = ({
  size = 'medium',
  border = true,
  cta,
  disableSave,
  isLoading,
  handleCancelClick,
  handleSaveClick,
  containerStyleProps = {},
  extraContent,
}: {
  cta: string;
  disableSave: boolean;
  isLoading: boolean;
  handleCancelClick: () => void;
  handleSaveClick: () => void;
  size?: 'small' | 'medium';
  border?: boolean;
  containerStyleProps?: {[key: string]: any};
  extraContent?: React.ReactNode;
}) => {
  return (
    <Box
      className={styles.keyResultActionContainer}
      style={containerStyleProps}
      borderTop={border ? 'Solid' : undefined}
      borderColor="Border Subtle"
      paddingTop={border ? '24' : '0'}
      paddingBottom={border ? '28' : '4'}
      paddingLeft="32"
    >
      {extraContent}
      <div className={styles.keyResultActionItemContainer}>
        <CancelButton
          size={size}
          fullWidth={false}
          className={styles.cancelButton}
          onClick={handleCancelClick}
          disabled={isLoading}
        >
          {'Cancel'}
        </CancelButton>
        <Button
          isLoading={isLoading}
          variant="primary"
          size={size}
          fullWidth={false}
          className={styles.addKeyResultButton}
          onClick={handleSaveClick}
          disabled={disableSave}
        >
          {cta}
        </Button>
      </div>
    </Box>
  );
};
